import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import asyncAction from 'modules/core/lib/asyncAction'
import buildUrl from 'modules/core/lib/buildUrl'

import {
  UseIncidenceFilterReturn,
  UseIncidenceFiltersType,
} from 'modules/bookkeepers/hooks/useIncidenceFilters'
import { FACTORIAL_APP, PROFESSIONALS_APP } from 'modules/bookkeepers/lib/amplitudeData'
import { DATA_VIEW, TDataViewValues } from 'modules/payroll_bundle/lib/Incidences/Status'

const EXPORT_FORMAT_PREFIX = 'incidences-'

type ExportProperties = {
  incidenceType: string
  legal_entity_id?: string
  status?: string
  firstDate?: string
  lastDate?: string
  search?: string
  dataView: TDataViewValues
}

const trackExport = (filters: ExportProperties) => {
  const application = filters.dataView == DATA_VIEW.bookkeeper ? PROFESSIONALS_APP : FACTORIAL_APP

  track(trackingEvents.bookkeeper.clients.exportFile, {
    export_format: `${EXPORT_FORMAT_PREFIX}${filters.incidenceType}`,
    application: application,
    ...filters,
  })
}

const addParams = (paramName: string, value?: string | string[]) => {
  if (!value) return []
  if (Array.isArray(value)) {
    return value.map((v) => [paramName, v])
  }
  return [[paramName, value]]
}

export const useDownloadIncidencesExport = (
  incidencesFilterData: UseIncidenceFilterReturn,
  dataView: TDataViewValues,
  incidenceType: string
) => {
  const { running, performAction: onSubmit } = useAsyncAction(
    async () => {
      const { filters, filterDate, search } = incidencesFilterData

      const { legal_entity_id, status } = filters
      const { firstDate, lastDate } = filterDate

      trackExport({ incidenceType, search, dataView, ...filters, ...filterDate })

      const paramsArray = [
        ...addParams('starts_on', firstDate),
        ...addParams('ends_on', lastDate),
        ...addParams('name_search', search),
        ...addParams('incidence_type', incidenceType),
        ...addParams('data_view', dataView),
        ...addParams('bookkeeper_view', dataView === DATA_VIEW.bookkeeper ? 'true' : 'false'),
        ...addParams('legal_entities_ids[]', legal_entity_id?.split(',')),
        ...addParams('statuses[]', status?.split(',')),
      ].filter((x) => x.length > 0)

      const queryParams = new URLSearchParams(paramsArray)

      const url = buildUrl(
        `/bookkeepers_management/incidences/export_incidences?${queryParams.toString()}`
      )
      window.location.href = url
    },
    {
      successFlash: false,
    }
  )

  return {
    running,
    onSubmit,
  }
}

// non-hook version
export const downloadIncidencesExport = async (
  incidencesFilterData: UseIncidenceFiltersType,
  dataView: TDataViewValues,
  incidenceType: string
) => {
  return asyncAction(
    async () => {
      const { filters, filterDate } = incidencesFilterData

      const { legal_entity_id, status } = filters
      const { firstDate, lastDate } = filterDate

      trackExport({ incidenceType, dataView, ...filters, ...filterDate })

      const paramsArray = [
        ...addParams('starts_on', firstDate),
        ...addParams('ends_on', lastDate),
        ...addParams('incidence_type', incidenceType),
        ...addParams('data_view', dataView),
        ...addParams('legal_entities_ids[]', legal_entity_id?.split(',')),
        ...addParams('statuses[]', status?.split(',')),
      ].filter((x) => x.length > 0)

      const queryParams = new URLSearchParams(paramsArray)

      const url = buildUrl(
        `/bookkeepers_management/incidences/export_incidences?${queryParams.toString()}`
      )
      window.location.href = url
    },
    {
      errorFlash: false,
      successFlash: false,
    }
  )
}
